import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import PaqueteriasCreate from "./PaqueteriasCreate";
import axios from "axios";
import { Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label } from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";

function ListadoPaqueterias() {
  const { user } = useContext(AuthContext);
  const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [paqueterias, setPaqueterias] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [diasEntrega, setDiasEntrega] = useState(0);
  const [idEdit, setIdEdit] = useState();
  const toggle = () => setModal(!modal);

  useEffect(() => {
    axios
      .get(URL_PAQUETERIAS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((response) => setPaqueterias(response.data))
      .catch((err) => console.log(err));
  }, []);

  function editPaqueteria(event) {
    event.preventDefault();
    axios
      .patch(`${URL_PAQUETERIAS}/${idEdit}`, { name, diasEntrega: Number(diasEntrega) || 0 }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Editar Paqueteria", detalle: name, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response?.data}` });
      });
  }

  function jalaInfo(id, nm, dias) {
    setName(nm);
    setDiasEntrega(dias || 0);
    setIdEdit(id);
    toggle();
  }

  return (
    <>
      <Header />
      <br /><br />
      <div className="container">
        {user.menu_articulos ? (
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h3 align="center">Paqueterias</h3>
                  <Table size="sm" striped borderless className="table-responsive-xl">
                    <thead>
                      <tr>
                        <th className="tituloTabla">Nombre</th>
                        <th className="tituloTabla">Días Entrega</th>
                        <th className="tituloTabla">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paqueterias.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => (
                        <tr key={a._id}>
                          <td>{a.name}</td>
                          <td align="center">{a.diasEntrega || 0}</td>
                          <td>
                            <Button color="info" size="sm" onClick={() => jalaInfo(a._id, a.name, a.diasEntrega)}>
                              <i className="far fa-edit"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <PaqueteriasCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Paqueteria</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input className="col-sm-12" type="text" value={name} required onChange={(e) => setName(e.target.value)} />
          <Label className="mr-sm-2 mt-2">Días de entrega</Label>
          <Input
            className="col-sm-12"
            type="number"
            min="0"
            value={diasEntrega}
            onChange={(e) => setDiasEntrega(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editPaqueteria}>Guardar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoPaqueterias;
